export const theme = {
  colors: {
    outchou_green: '#44B69D',
    outchou_green_hover: '#3DA38C',
    outchou_blue: '#283275',
    outchou_blue_hover: '#1D2558',
    outchou_yellow: '#F7E304',
    white: '#FFFFFF',
    gray: '#666666',
    light_gray: '#F4F4EC',
    light_beige: '#F4F4EC',
  },
  fonts: {
    title: '"Clash Display", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body: "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  }
}; 